<template>
  <div class="card-body">
    <div
      role="alert"
      aria-live="polite"
      aria-atomic="true"
      class="alert alert-secondary"
    >
      <i class="mdi mdi-alert-circle-outline me-2"></i>
      เพื่อไม่ให้ระบบทำงานช้า รบกวน Import ข้อมูลครั้งละไม่เกิน 500
      รายการ
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-row form-group">
          <div class="col-md-8">
            <div class="form-row form-group">
              <label class="col-md-2 col-form-label">Upload</label>
              <div class="col-md-8">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent"
                      ><i class="bx bxs-folder-open"></i
                    ></span>
                  </div>
                  <b-form-file
                    placeholder="Choose file"
                    accept=".xls, .xlsx"
                    v-on:change="importExcel($event)"
                    v-model="file"
                  ></b-form-file>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right">
            <div class="button-items">
              <button
                v-if="isClear && !isLoading"
                type="button"
                class="btn btn-light waves-effect"
                @click="onClear()"
              >
                <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                Reset
              </button>
              <button
                @click="onDownloadTemplate"
                type="button"
                class="btn btn-download-template"
              >
                <i class="mdi mdi-download" />Download Template
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="isSuccessProductItems" >
      <hr />
      <div class="form-group row">
        <div class="col-sm-12 col-md-9">
          <h5 style="color: green">สินค้าที่นำเข้าระบบได้</h5>
        </div>
        <div class="col-sm-12 col-md-3">
          <div class="input-group md-form form-sm text-right">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <span class="bx bx-search-alt"></span>
              </span>
            </div>
            <input
              v-model="searchProductCatalog"
              class="form-control my-0 py-1"
              type="search"
              placeholder="ค้นหา"
              aria-label="Search"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <!-- {{ second }} -->
            <!-- :filter="searchProductCatalog" -->
            <b-table
              class="table table-centered table-nowrap"
              ref="productcatalogtable"
              align="center"
              :empty-text="'ไม่พบข้อมูล'"
              :show-empty="!isSuccessProductItems"
              :bordered="true"
              :items="filterSuccessProductItems"
              v-bind:fields="filterProductCatalogTablefields"
              :perPage="pageSize"
              :current-page="pageNo"
            >
              <template v-slot:cell(index)="data">
                <div class="text-right">
                  {{ (firstRowOnPage + data.index) | number }}
                </div>
              </template>
              <template v-slot:cell(inventory_status)="data">
                <span
                  v-if="data.value"
                  class="label"
                  :class="'label-' + data.value.toLowerCase()"
                  v-html="data.value"
                ></span>
              </template>
              <template v-slot:cell(sale_status)="data">
                <span
                  v-if="data.value"
                  class="label"
                  :class="'label-' + data.value.toLowerCase()"
                  v-html="data.value"
                ></span>
              </template>
              <template v-slot:head(pages)="data">
                <div :class="data.field.tdClass">
                  {{ data.label }}
                </div>
                <div class="text-right">
                  <input
                    v-model="pages"
                    :readonly="!isSuccessProductItems"
                    type="number"
                    class="form-control form-default text-right"
                    min="0"
                  />
                </div>
              </template>
              <template v-slot:head(remark)="data">
                <div :class="data.field.tdClass">
                  {{ data.label }}
                </div>
                <div class="text-left">
                  <input
                    v-model="remark"
                    :readonly="!isSuccessProductItems"
                    type="text"
                    class="form-control form-default text-left"
                  />
                </div>
              </template>
              <template v-slot:cell(pages)="data">
                <input
                  v-model="filterSuccessProductItems[(firstRowOnPage + data.index) - 1].pages"
                  type="number"
                  class="form-control form-default text-right"
                  min="0"
                />
              </template>
              <template v-slot:cell(remark)="data">
                <input
                  v-model="filterSuccessProductItems[(firstRowOnPage + data.index) - 1].remark"
                  type="text"
                  class="form-control form-default"
                />
              </template>
              <template v-slot:cell(action)="data">
                <div class="text-center">
                  <a
                    @click="onDeleteProductCatalog(data.item.id)"
                    class="btn btn-ico text-danger"
                    ><i class="bx bx-trash"></i
                  ></a>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div style="position: relative; top: 7px">
            รายการที่ {{ firstRowOnPage | number }} -
            {{ lastRowOnPage | number }} จากทั้งหมด
            {{ totalRecords | number }} รายการ
          </div>
        </div>
        <div class="col-lg-8">
          <b-pagination
            :total-rows="totalRecords"
            :per-page="pageSize"
            v-model="pageNo"
            @change="onPagination($event)"
            class="pagination pagination-rounded justify-content-end mb-2"
          />
        </div> 
      </div>
      <div class="form-group mb-4 text-center">
        <div class="button-items">
          <!-- <b-spinner
            v-if="isLoading"
            class="m-2"
            variant="primary"
            role="status"
          ></b-spinner> -->
          <button
            v-if ="isSuccessProductItems && modeData === 'Create'" 
            @click="onBeforeSave()"
            type="button"
            class="btn btn-primary"
            :disabled="isLoading"
          >
            <i class="bx bx-save" />Save
          </button>
          <button
            v-if ="isSuccessProductItems && modeData === 'Delete'" 
            @click="onBeforeSave()"
            type="button"
            class="btn btn-danger"
            :disabled="isLoading"
          >
            <i class="bx bx-save" />Delete
          </button>
          <!-- <button
            @click="onSave()"
            type="button"
            class="btn btn-info"
          >
            <i class="bx bx-check-double" />Apply
          </button> -->
          <!-- <button
            v-if="
              productItems &&
                productItems.some(s => s.is_error == true)
            "
            type="button"
            class="btn btn-danger"
            @click="onClearRowDataError()"
          >
            Clear Error
          </button> -->
        </div>
      </div>
    </template>
    <template v-if="isErrorProductItems">
      <hr />
      <div class="form-group row">
        <div class="col-sm-12 col-md-9">
          <h5 style="color: red">สินค้าที่นำเข้าระบบไม่ได้</h5>
        </div>
        <div class="col-sm-12 col-md-3">
          <div class="input-group md-form form-sm text-right">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <span class="bx bx-search-alt"></span>
              </span>
            </div>
            <input
              v-model="errorSearchProductCatalog"
              class="form-control my-0 py-1"
              type="search"
              placeholder="ค้นหา"
              aria-label="Search"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <!-- {{ second }} -->
            <!-- :filter="errorSearchProductCatalog" -->
            <b-table
              class="table table-centered table-nowrap"
              ref="productcatalogtable"
              align="center"
              :empty-text="'ไม่พบข้อมูล'"
              :show-empty="!isErrorProductItems"
              :bordered="true"
              :items="filterErrorProductItems"
              v-bind:fields="errorProductcatalogTablefields"
              :perPage="errorPageSize"
              :current-page="errorPageNo"
            >
              <template v-slot:cell(index)="data">
                <div class="text-right">
                  {{ (errorFirstRowOnPage + data.index) | number }}
                </div>
              </template>
              <template v-slot:cell(inventory_status)="data">
                <span
                  v-if="data.value"
                  class="label"
                  :class="'label-' + data.value.toLowerCase()"
                  v-html="data.value"
                ></span>
              </template>
              <template v-slot:cell(sale_status)="data">
                <span
                  v-if="data.value"
                  class="label"
                  :class="'label-' + data.value.toLowerCase()"
                  v-html="data.value"
                ></span>
              </template>
              <template v-slot:head(pages)="data">
                <div :class="data.field.tdClass">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(remark)="data">
                <div :class="data.field.tdClass">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(pages)="data">
                <!-- <input
                  v-model="filterErrorProductItems[(errorFirstRowOnPage + data.index) - 1].pages"
                  type="number"
                  class="form-control form-default text-right"
                  min="0"
                /> -->
                <div :class="data.field.tdClass">
                  {{ filterErrorProductItems[(errorFirstRowOnPage + data.index) - 1].pages }}
                </div>
              </template>
              <template v-slot:cell(remark)="data">
                <!-- <input
                  v-model="filterErrorProductItems[(errorFirstRowOnPage + data.index) - 1].remark"
                  type="text"
                  class="form-control form-default"
                /> -->
                <div :class="data.field.tdClass">
                  {{ filterErrorProductItems[(errorFirstRowOnPage + data.index) - 1].remark }}
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <div class="text-center">
                  <a
                    @click="onDeleteProductCatalog(data.item.id)"
                    class="btn btn-ico text-danger"
                    ><i class="bx bx-trash"></i
                  ></a>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div style="position: relative; top: 7px">
            รายการที่ {{ errorFirstRowOnPage | number }} -
            {{ errorLastRowOnPage | number }} จากทั้งหมด
            {{ errorTotalRecords | number }} รายการ
          </div>
        </div>
        <div class="col-lg-8">
          <b-pagination
            :total-rows="errorTotalRecords"
            :per-page="errorPageSize"
            v-model="errorPageNo"
            @change="onErrorPagination($event)"
            class="pagination pagination-rounded justify-content-end mb-2"
          />
        </div> 
      </div>
       <div class="form-group mb-4 text-center">
        <div class="button-items">
          <button
            @click="exportErrorAll()"
            v-if="mode !== 'view'"
            type="button"
            class="btn btn-secondary"
          >
            <i class="bx bx-download" />Download Error Product
          </button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import productService from '@/helpers/service/product-service'
import catalogService from '@/helpers/service/catalog-service'
import productCatalogService from '@/helpers/service/product-catalog-service'
import XLSX from 'xlsx'
import moment from 'moment'
import { Workbook } from 'exceljs'
import * as fs from 'file-saver'
import { ExportFileName } from '@/helpers/utils/format-date.js'
import { eventBus } from '@/main.js'

export default {
  props: {
    mode: {
      type: String,
      default: '',
    },
    // defaultListProductItems: {
    //   type: Array,
    //   default: () => [],
    // },
    model: {
      type: Object,
      default: () => {},
    },
    catalogIdSelected: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pages: null,
      remark: null,
      productId: '',
      typeId: '',
      typeName: '',
      catalogId: '',
      catalogName: '',
      reloadCatalogType: false,
      reloadCatalog: false,
      file: null,
      // fileName: '',
      exportData: [
        {
          'รหัสสินค้า (OFM)': '',
          เลขหน้า: '',
          หมายเหตุเพิ่มเติม: '',
        },
      ],
      toggle: false,
      filter: {
        name: '',
      },
      searchProductCatalog: null,
      pageSize: 5,
      pageNo: 1,
      totalPages: 0,
      firstRowOnPage: 1,
      lastRowOnPage: 0,
      totalRecords: 0,
      productItems: [],
      // tempProductItems: [],
      productCatalogTablefields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'pages',
          label: 'เลขหน้า',
          tdClass: 'text-center',
          thStyle: 'width:120px',
        },
        {
          key: 'remark',
          label: 'หมายเหตุเพิ่มเติม',
          tdClass: 'text-center',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      errorSearchProductCatalog: null,
      errorPageSize: 5,
      errorPageNo: 1,
      errorTotalPages: 0,
      errorFirstRowOnPage: 1,
      errorLastRowOnPage: 0,
      errorTotalRecords: 0,
      // tempProductItems: [],
      errorProductcatalogTablefields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'pages',
          label: 'เลขหน้า',
          tdClass: 'text-center',
          thStyle: 'width:120px',
        },
        {
          key: 'remark',
          label: 'หมายเหตุเพิ่มเติม'
        },
        {
          key: 'error_message',
          label: 'Error Message',
        }
      ],
      isLoading: false,
      second: 0,
      start: null,
      excel: {
        head_data_validation: {},
        header_excel_style_background_has: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'cc0000' },
        },
        header_excel_style_background: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '4472C4' },
        },
        header_excel_style_font: {
          bold: true,
          size: 12,
          color: { argb: 'ffffff' },
        },
        header_excel: [
          {
            key: 'index',
            value: 'ลำดับ',
          },
          {
            key: 'sku_code_ofm',
            value: 'รหัสสินค้า (OFM)',
          },
          {
            key: 'product_display_name.th',
            value: 'ชื่อสินค้า',
          },
          {
            key: 'inventory_status',
            value: 'สถานะสินค้า',
          },
          {
            key: 'sale_status',
            value: 'สถานะการขาย',
          },
          {
            key: 'pages',
            value: 'เลขหน้า',
          },
          {
            key: 'remark',
            value: 'หมายเหตุเพิ่มเติม',
          },
          {
            key: 'error_message',
            value: 'Error Message',
          }
        ],
        template_file_name: 'Data',
      },
      modeData: '',
      isLoadProduct: false,
      listProductItems: []
    }
  },
  computed: {
    isProductItems() {
      return this.productItems !== undefined && this.productItems !== null && this.productItems.length > 0
    },
    isSuccessProductItems() {
      return this.productItems !== undefined && this.productItems !== null && this.productItems.length > 0 && this.productItems.some(q => !q.is_error)
    },
    isErrorProductItems() {
      return this.productItems !== undefined && this.productItems !== null && this.productItems.length > 0 && this.productItems.some(q => q.is_error)
    },
    filterSuccessProductItems() {
      // let filterProducts = this.productItems.filter(q => !q.is_error)
      // if (this.searchProductCatalog === null || this.searchProductCatalog === '') {
      //   return filterProducts
      // }
      // else {
      //   return filterProducts.filter(q => q.id === undefined 
      //                               || q.id === null 
      //                               || q.id === '' 
      //                               || q.id.toLowerCase().startsWith(this.searchProductCatalog.toLowerCase()))
      // }
      return this.productItems.filter(q => !q.is_error && ( (this.searchProductCatalog === null || this.searchProductCatalog === '')  
                                                            || (q.id === undefined || q.id === null || q.id === '')
                                                            || q.id.toLowerCase().startsWith(this.searchProductCatalog.toLowerCase())
                                                            || q.inventory_status === this.searchProductCatalog))
    },
    
    filterErrorProductItems() {
      return this.productItems.filter(q => q.is_error && ( (this.errorSearchProductCatalog === null || this.errorSearchProductCatalog === '')  
                                                            || (q.id === undefined || q.id === null || q.id === '')
                                                            || q.id.toLowerCase().startsWith(this.errorSearchProductCatalog.toLowerCase())))
    },
    successProductItems() {
      return this.productItems.filter(q => !q.is_error)
    },
    errorProductItems() {
      return this.productItems.filter(q => q.is_error)
    },
    isClear() {
      return this.file !== null || this.isProductItems
    },
    filterProductCatalogTablefields() {
      //if (this.modeData === 'Delete') return this.productCatalogTablefields.filter(q => q.key !== 'pages' && q.key !== 'remark')
      return this.productCatalogTablefields
    }
  },
  watch: {
    mode(value) {
      let modeData = value === 'Delete Product in Catalog' ? 'Delete' : 'Create'
      console.log('modeData', modeData, this.modeData )
      if (this.modeData !== modeData) this.onClear()
      this.modeData = modeData
    },
    filterSuccessProductItems() {
      this.onPagination(this.pageNo)
    },
    filterErrorProductItems() {
      this.onErrorPagination(this.pageNo)
    },
    // productItems: {
    //   handler: function(val) {
    //     val.forEach(element => {
    //       if (element.is_error) {
    //         element._rowVariant = 'danger'
    //       } else {
    //         element._rowVariant = ''
    //       }
    //     })
    //   },
    //   deep: true,
    // },
    pages: function(value) {
      if (this.successProductItems.length > 0) {
        this.successProductItems.forEach(element => {
          if (element.inventory_status !== 'Delete') {
            element.pages = value
          }
        })
      }
    },
    remark: function(value) {
      if (this.successProductItems.length > 0) {
        this.successProductItems.forEach(element => {
          if (element.inventory_status !== 'Delete') {
            element.remark = value
          }
        })
      }
    },
  },
  mounted: function() {
    this.modeData = this.mode === 'Delete Product in Catalog' ? 'Delete' : 'Create'
  },
  methods: {
    async getProductCatalog() {
      try {
        this.listProductItems = []
        let params = new URLSearchParams()
        params.append('pageSize', 999999)
        params.append('pageNo', 1)
        params.append('sort', 'product_id')
        let result = await catalogService.GetCatalogProductsByIdLoadingAsync(
          this.catalogIdSelected,
          params
        )
        if (result.status === 200) {
          if (result.data.items && result.data.items.length > 0) {
            this.resultData = result.data
            // console.log('load productItems', result.data)
            result.data.items.forEach(element => {
              element.skus.forEach(element2 => {
                let displayName = { th: '', en: '' }
                if(element2.product_names !== undefined && element2.product_names !== null && element2.product_names.some(f => f.type.toLowerCase() === 'online')) {
                  displayName = element2.product_names.find(
                    f => f.type.toLowerCase() === 'online'
                  ).display_name
                }

                var tempItem = {
                  id: element2.sku_id,
                  product_id: element.product_id,
                  sku_code_ofm: element2.sku_id,
                  product_display_name: {
                    th: displayName.th,
                    en: displayName.en
                  },
                  inventory_status: element2.product_status.inventory,
                  sale_status: element2.product_status.sale,
                  pages:
                    element2.pages && element2.pages.length > 0
                      ? element2.pages[0]
                      : [0],
                  remark: element2.remark,
                }
                this.listProductItems.push(tempItem)
              })
            })
          }
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          console.log('error', result.response.data.message)
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      } catch (err) {
        console.log('Error : ', err)
      }
    },
    async onPagination(pageNo) {
      this.pageNo = pageNo
      // this.pageNo = pageNo
      this.totalRecords = this.filterSuccessProductItems.length
      this.totalPages = Math.ceil(this.filterSuccessProductItems.length / this.pageSize)
      this.firstRowOnPage = (pageNo - 1) * this.pageSize + 1
      this.lastRowOnPage =
        this.pageSize <= 0
          ? this.totalRecords
          : Math.min(pageNo * this.pageSize, this.totalRecords)

      // console.log('pageNo',pageNo)
      // console.log('pageNo',this.pageNo)
      // console.log('this.totalRecords',this.totalRecords)
      // console.log('this.pageSize',this.pageSize)
      // console.log('this.totalPages',this.totalPages)
      // console.log('this.firstRowOnPage',this.firstRowOnPage)
      // console.log('this.lastRowOnPage',this.lastRowOnPage)
    },
     async onErrorPagination(pageNo) {
      this.errorPageNo = pageNo
      // this.pageNo = pageNo
      this.errorTotalRecords = this.filterErrorProductItems.length
      this.errorTotalPages = Math.ceil(this.filterErrorProductItems.length / this.errorPageSize)
      this.errorFirstRowOnPage = (pageNo - 1) * this.errorPageSize + 1
      this.errorLastRowOnPage =
        this.errorPageSize <= 0
          ? this.errorTotalRecords
          : Math.min(pageNo * this.errorPageSize, this.errorTotalRecords)

      // console.log('pageNo',pageNo)
      // console.log('errorPageNo',this.errorPageNo)
      // console.log('this.errorTotalRecords',this.errorTotalRecords)
      // console.log('this.errorPageSize',this.errorPageSize)
      // console.log('this.errorTotalPages',this.errorTotalPages)
      // console.log('this.errorFirstRowOnPage',this.errorFirstRowOnPage)
      // console.log('this.errorLastRowOnPage',this.errorLastRowOnPage)
    },
    // async onFilter() {
    //   if (this.filter.name) {
    //     this.productItems = []
    //     // this.tempProductItems = []
    //     this.pages = null
    //     this.remark = null
    //     let params = new URLSearchParams()
    //     params.append('pageNo', 1)
    //     params.append('pageSize', 9999)
    //     params.append('sort', 'product_id')
    //     params.append('product_id_or_sku_code_ofm', this.filter.name.trim())
    //     let result = await productService.getProductSkuListAsync(params)
    //     if (result.status === 200 || result.status === 201) {
    //       if (result.data.items && result.data.items.length === 0) {
    //         this.$utils.notification('warning', 'ไม่พบรหัสสินค้าในระบบ', 2000)
    //       } else {
    //         result.data.items.forEach(element => {
    //           var displayName = element.product_names.find(
    //             f => f.type === 'Online'
    //           ).display_name
    //           var tempItem = {
    //             id: element.id,
    //             product_id: element.product_id,
    //             sku_code_ofm: element.id,
    //             product_display_name: {
    //               th: displayName.th,
    //               en: displayName.en,
    //             },
    //             inventory_status: element.product_status.inventory,
    //             sale_status: element.product_status.sale,
    //             pages: null,
    //             remark: null,
    //             error_message: element.error_message,
    //             is_error: element.is_error,
    //           }

    //           // var tempProduct = {
    //           //   id: element.id,
    //           //   pages: null,
    //           //   remark: null,
    //           //   is_error: element.is_error,
    //           // }
    //           this.productItems.push(tempItem)
    //           // this.tempProductItems.push(tempProduct)
    //         })

    //         this.productId = result.data.items
    //           ? result.data.items[0].product_id
    //           : ''
    //       }
    //     } else if (result.status === 404) {
    //       this.$utils.notification('error', 'ไม่พบรหัสสินค้าในระบบ', 2000)
    //     } else if (
    //       (result.status && result.status !== 500) ||
    //       (result.response && result.response.status !== 500)
    //     ) {
    //       this.$utils.notification('error', result.response.data.message, 2000)
    //     }
    //   }
    // },
    async onUpload(value) {
      this.productItems = []
      // this.tempProductItems = []
      this.pages = null
      this.remark = null
      let listSkuCodeOFM = []
      value.forEach(element => {
        listSkuCodeOFM.push(element.sku_code_ofm)
      })
      let objModel = {
        sku_code_ofms: listSkuCodeOFM,
      }
      // console.log('api')
      if (!this.isLoadProduct) {
        await this.getProductCatalog()
        this.isLoadProduct = true
      }
      // console.log('get product catalog')
      let result = await productService.searchProductSkuIncludeProductAsync(
        objModel
      )

      // console.log('result', result)
      if (result.status === 200 || result.status === 201) {
        result.data.forEach((element, index) => {
          let is_error = element.is_error
          let error_message = element.error_message
          if(!is_error && this.modeData === 'Delete') {
            if(!this.listProductItems.some(q => q.id === element.id && q.product_id === element.product_id)) {
              is_error = true
              error_message = "ไม่พบข้อมูลใน catalog นี้"
            }
          }

          if (!is_error 
          && this.modeData === 'Create' 
          && element.product_status.inventory !== '' 
          && element.product_status.inventory.toLowerCase() === 'delete') {
            is_error = true
            error_message = "สินค้าสถานะ Delete"
          }
            

          var tempItem = {}
            let displayName = { th: '', en: '' }
            if(element.product_names !== undefined && element.product_names !== null && element.product_names.some(f => f.type.toLowerCase() === 'online')) {
              displayName = element.product_names.find(
                f => f.type.toLowerCase() === 'online'
              ).display_name
            }
            
            let isValue = value.some(f => f.sku_code_ofm === element.id)
            // let isPages = value.some(f => f.sku_code_ofm === element.id).pages
            // let isRemark = value.some(f => f.sku_code_ofm === element.id).remark
            // console.log('value', value)
            // console.log('isValue', isValue)
            // console.log('element', element)
            tempItem = {
              id: element.id,
              product_id: element.product_id,
              sku_code_ofm: element.id,
              product_display_name: {
                th: displayName.th,
                en: displayName.en,
              },
              inventory_status: element.product_status.inventory,
              sale_status: element.product_status.sale,
              pages: isValue ? value.find(f => f.sku_code_ofm === element.id).pages : 0,
              remark: isValue ? value.find(f => f.sku_code_ofm === element.id).remark : '',
              error_message: error_message,
              is_error: is_error,
              // is_error: index > 0 && index < 18 ? true : element.is_error,
            // }
            // tempProduct = {
            //   id: element.id,
            //   pages: value.find(f => f.sku_code_ofm === element.id).pages,
            //   remark: value.find(f => f.sku_code_ofm === element.id).remark,
            //   is_error: element.is_error,
            // }
          }
          this.productItems.push(tempItem)
          // this.tempProductItems.push(tempProduct)
        })
        // this.second =  moment().diff(this.start, "seconds")
      
        this.onPagination(1)
        this.onErrorPagination(1)
      } else if (result.status === 404) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูลของสินค้า (รหัสสินค้านี้ไม่มีข้อมูล) ในระบบ',
          2000
        )
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onBeforeSave() {
      await this.$utils
                .confirmAlertDisplay(
                  `ต้องการ${this.modeData === 'Create' ? 'บันทึก' : 'ลบ'}ข้อมูลใช่หรือไม่`,
                  ''
                ).then(async result => {
                  if (result) await this.onSave()
                })
    },
    async onSave() {
      this.isLoading = true
      this.start = moment()
      if (!this.isSuccessProductItems) {
        this.$utils.notification(
          'error',
          this.modeData === 'Delete' ? 'ไม่มีรายการสินค้าให้ลบ' : 'ไม่มีรายการสินค้าให้ Add เพิ่ม',
          2000
        )
      } 
      // else if (this.productItems.some(s => s.is_error == true)) {
      //   this.$utils.notification(
      //     'error',
      //     'ไม่สามารถดำเนินการต่อได้เนื่องจากชุดยังมูลยังมีรายการที่ผิดพลาด',
      //     2000
      //   )
      // } 
      else {
        // if (
        //   this.productItems.some(p => p.inventory_status === 'Delete') && this.modeData === 'Create'
        // ) {
        //   this.$utils.notification(
        //     'error',
        //     'มีสินค้าสถานะ Delete อยู่ในรายการ ไม่สามารถดำเนินการต่อได้',
        //     2000
        //   )
        // } else {
        let checkExist = false
        if (this.listProductItems.length > 0) {
          let skus = this.listProductItems.map(p => p.id)
          checkExist = this.successProductItems.some(p => skus.includes(p.id))
          if (checkExist && this.modeData === 'Create') {
            await this.$utils
              .confirmAlertDisplay(
                `มีข้อมูลสินค้านี้อยู่ใน Catalog แล้ว ต้องการแก้ไขข้อมูลใหม่ใช่หรือไม่`,
                ''
              )
              .then(async result => {
                if (result) {
                  await setTimeout(async() => await this.onSubmit(), 300)
                }
              })
          } else {
            await setTimeout(async() => await this.onSubmit(), 300)
          }
        } else {
          await setTimeout(async() => await this.onSubmit(), 300)
        }
        // }
      }
    },
    async onSubmit() {
      this.second =  moment().diff(this.start, "seconds")
      // console.log('onSave this.second', this.second)
      this.start = moment()
      let products = []
      let items = JSON.parse(JSON.stringify(this.successProductItems.map(q => ({ product_id: q.product_id, id: q.id, pages: q.pages, remark: q.remark }))))
      items.forEach(element => {
        if (element.product_id !== undefined && element.product_id !== null && element.product_id !== '') {
          let tempListPage = []
          if (
            element.pages !== null &&
            element.pages !== undefined &&
            element.pages !== ''
          ) {
            tempListPage.push(element.pages)
          }

          var tempSku = {
            sku_id: element.id,
            pages: tempListPage,
            remark: element.remark,
          }

          if (products.length > 0) {
            if (products.some(f => f.product_id === element.product_id)) {
              let modelProduct = products.find(f => f.product_id === element.product_id)
              modelProduct.skus.push(tempSku)
            } else {
              products.push({
                product_id: element.product_id,
                skus: [tempSku],
              })
            }
          } else {
            products.push({
              product_id: element.product_id,
              skus: [tempSku],
            })
          }
        }
      })
      this.model.products = products
      // this.second =  moment().diff(this.start, "seconds")
      // console.log('onSubmit this.second', this.second)
      // this.start = moment()
      this.isLoading = false
      console.log("this.model", this.model)
      this.model.mode = this.modeData
      let result = await productCatalogService.updateProductCatalogAsync(
        this.model.id,
        this.model
      )
      if (result.status && result.status === 204) {
        this.isLoadProduct = false
        if (this.modeData === 'Delete') {
          this.$utils.notification('success', 'ลบข้อมูลสำเร็จ', 1500)
          this.$emit('onSave', null)
        } else {
          this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
          this.$emit('onSave', this.productItems)
        }
        
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
        this.$emit('onSave', null)
      } else {
        this.$utils.notification('error', "เกิดข้อผิดพลาด", 2000)
        this.$emit('onSave', null)
      }
      this.onClear()
      // this.second =  moment().diff(this.start, "seconds")
    },
    onClear() {
      this.productId = ''
      this.typeId = ''
      this.typeName = ''
      this.catalogId = ''
      this.catalogName = ''
      this.reloadCatalogType = false
      this.reloadCatalog = false
      this.file = null
      this.filter = {
        name: '',
      }
      this.searchProductCatalog = null
      this.productItems = []
      // this.tempProductItems = []
      this.pages = null
      this.remark = null

      this.$nextTick(() => {
        this.reloadCatalogType = true
        this.reloadCatalog = true
      })
    },
    onClearProduct() {
      this.productItems = []
      // this.tempProductItems = []
      this.productId = ''
      this.pages = null
      this.remark = null
    },
    async getDetail(id) {
      try {
        this.isLoading = true
        let params = new URLSearchParams()
        params.append('pageSize', 999999)
        params.append('sort', 'product_id')
        let result = await catalogService.GetCatalogProductsByIdAsync(
          id,
          params
        )
        this.productItems = []
        // this.tempProductItems = []
        this.pages = null
        this.remark = null
        if (result.status === 200) {
          if (result.data.items && result.data.items.length > 0) {
            result.data.items.forEach(element => {
              element.skus.forEach(element2 => {
                var displayName = element2.product_names.find(
                  f => f.type === 'Online'
                )
                var tempItem = {
                  id: element2.sku_id,
                  product_id: element.product_id,
                  sku_code_ofm: element2.sku_id,
                  product_display_name: {
                    th: displayName ? displayName.display_name.th : '',
                    en: displayName ? displayName.display_name.en : '',
                  },
                  inventory_status: element2.product_status.inventory,
                  sale_status: element2.product_status.sale,
                  pages:
                    element2.pages && element2.pages.length > 0
                      ? element2.pages[0]
                      : [0],
                  remark: element2.remark,
                  error_message: '',
                  is_error: false,
                }
                this.productItems.push(tempItem)
              })
            })
          }
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          console.log('error', result.response.data.message)
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        console.log('Error : ', err)
      }
    },
    async onClone(value) {
      let listSkuId = []
      value.forEach(element => {
        listSkuId.push(element.sku_id)
      })
      let objModel = {
        sku_id: listSkuId,
      }
      let result = await productService.searchProductSkuIncludeProductAsync(
        objModel
      )
      if (result.status === 200 || result.status === 201) {
        result.data.forEach(element => {
          var displayName = element.product_names.find(f => f.type === 'Online')
            .display_name
          var tempItem = {
            id: element.id,
            product_id: element.product_id,
            sku_code_ofm: element.id,
            product_display_name: {
              th: displayName.th,
              en: displayName.en,
            },
            inventory_status: element.product_status.inventory,
            sale_status: element.product_status.sale,
            pages: value.find(f => f.sku_id === element.id).pages,
            remark: value.find(f => f.sku_id === element.id).remark,
            error_message: element.error_message,
            is_error: element.is_error,
          }

          this.productItems.push(tempItem)
        })
      } else if (result.status === 404) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูลของสินค้า (รหัสสินค้านี้ไม่มีข้อมูล) ในระบบ',
          2000
        )
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    onDeleteProductCatalog(id) {
      this.productItems.splice(
        this.productItems.findIndex(element => element.id === id),
        1
      )
    },
    onDownloadTemplate() {
      const dataWS = XLSX.utils.json_to_sheet(this.exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'TemplateProductCatalog.xlsx')
    },
    async importExcel(e) {
      this.start = moment()
      var vm = this
      var selectedFile = e.target.files[0]
      var reader = new FileReader()
      reader.onload = function(event) {
        var items = []
        var data = event.target.result
        var workbook = XLSX.read(data, {
          type: 'binary',
        })
        workbook.SheetNames.forEach(function(sheetName) {
          var row = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName]
          )

          var headers = ['รหัสสินค้า (OFM)', 'เลขหน้า', 'หมายเหตุเพิ่มเติม']
          var j = 0
          for (var key in row[0]) {
            if (
              key !== headers[j] &&
              key !== null &&
              key !== undefined &&
              key !== ''
            ) {
              // vm.fileName = ''
              vm.items = []
              // vm.Response('500', 'Format ของ File Excel ผิดรูปแบบ', '', 'Error')
              vm.$utils.notification(
                'error',
                'Format ของ File Excel ผิดรูปแบบ',
                2000
              )
              return
            }
            j++
          }
          for (var i = 0; i < row.length; i++) {
            // console.log('รหัสสินค้า (OFM)', row[i]['รหัสสินค้า (OFM)'])
            // console.log('เลขหน้า', row[i]['เลขหน้า'])
            // console.log('หมายเหตุเพิ่มเติม', row[i]['หมายเหตุเพิ่มเติม'])
            // console.log('row[i]', row[i])
            if (
              !(
                (row[i]['รหัสสินค้า (OFM)'] === '' ||
                  row[i]['รหัสสินค้า (OFM)'] === null ||
                  row[i]['รหัสสินค้า (OFM)'] === undefined) &&
                (row[i]['เลขหน้า'] === '' ||
                  row[i]['เลขหน้า'] === null ||
                  row[i]['เลขหน้า'] === undefined) &&
                (row[i]['หมายเหตุเพิ่มเติม'] === '' ||
                  row[i]['หมายเหตุเพิ่มเติม'] === null ||
                  row[i]['หมายเหตุเพิ่มเติม'] === undefined)
              )
            ) {
              items.push({
                sku_code_ofm: String(row[i]['รหัสสินค้า (OFM)']),
                pages: row[i]['เลขหน้า'],
                remark: row[i]['หมายเหตุเพิ่มเติม'],
              })
            }
          }
        })
        vm.onUpload(items)
        // vm.fileName = selectedFile.name
      }
      reader.onerror = function(event) {
        if (event.target.error.name === 'NotReadableError') {
          alert("Canno't read file !")
        }
      }
      reader.readAsBinaryString(selectedFile)
    },
    onClearRowDataError() {
      this.productItems = this.productItems.filter(f => f.is_error == false)
    },
    getFile() {
      document.getElementById('file').value = ''
      document.getElementById('file').click()
    },
    exportErrorAll() {
      let workbook = new Workbook()

      let worksheet = workbook.addWorksheet('Data')

      var headerTexts = []
      var headerKeys = []

      this.excel.header_excel.forEach(item => {
        headerTexts.push(item.value)
        headerKeys.push(item.key)
      })

      worksheet.getRow(1).values = headerKeys
      worksheet.getRow(2).values = headerTexts

      worksheet.getRow(1).fill = this.excel.header_excel_style_background
      worksheet.getRow(2).fill = this.excel.header_excel_style_background
      worksheet.getRow(1).font = this.excel.header_excel_style_font
      worksheet.getRow(2).font = this.excel.header_excel_style_font

      // worksheet.getRow(1).values = this.headExcel;

      this.errorProductItems.forEach((data, index) => {
        var tmpDataExorts = []
        tmpDataExorts.push(index + 1)
        tmpDataExorts.push(data.sku_code_ofm)
        tmpDataExorts.push(data.product_display_name.th)
        tmpDataExorts.push(data.inventory_status)
        tmpDataExorts.push(data.sale_status)
        tmpDataExorts.push(data.pages)
        tmpDataExorts.push(data.remark)
        tmpDataExorts.push(data.error_message)
        worksheet.getRow(index + 3).values = tmpDataExorts
      })

      worksheet.columns.forEach(column => {
        const num = column.values[1]
        if (num != undefined) {
          column.width = column.values[1].length
        }
      })

      workbook.xlsx.writeBuffer().then(data => {
        let blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        fs.saveAs(blob, ExportFileName(this.excel.template_file_name))
      })
    }
  },
}
</script>
